import { IActionContext } from '../helpers/ActionContext';
import { L10n } from '../L10n/L10n';
import { IErrorItem } from '../models/MultipleItemResult';
import { Set } from '../models/Set';
import { Module } from '../Module';
import { Schedules } from '../resources/Schedules';
import { IResult } from '../ServerApi/types/IResponse';
import { ISchedule, ScheduleActions } from '../ServerApi/types/ISchedule';
import { ActionHelpers } from './ActionHelpers';
import { ConfirmActionDialog, IConfirmActionDialogInstance } from './ConfirmActionDialog';
import { ScheduleErrors } from './ScheduleErrors';

export class DeleteSchedulesAction {

  public static $inject = ['ScheduleErrors', 'ActionHelpers', 'ConfirmActionDialog', '$translate', 'Schedules'];

  constructor(
    private ScheduleErrors: ScheduleErrors,
    private ActionHelpers: ActionHelpers,
    private ConfirmActionDialog: ConfirmActionDialog,
    private $translate: ng.translate.ITranslateService,
    private Schedules: Schedules) { }

  public deleteSchedules(schedules: Set<ISchedule>, context: IActionContext): ng.IPromise<IResult> {

    const scheduleCount = schedules.size();
    const extractTaskCount = this.countExtractTasks(schedules);
    const subscriptionScheduleCount = this.countSubscriptionSchedules(schedules);
    const runFlowTaskCount = this.countFlowTasks(schedules);

    let bodyText: string;

    if (scheduleCount === 1) {
      if (subscriptionScheduleCount > 0) {
        bodyText = this.$translate.instant('confirmDeleteSubscriptionSchedule', {
          SCHEDULE_NAME: L10n.elideIfLong(schedules.first().name)
        });
      } else if (runFlowTaskCount > 0) {
        bodyText = this.$translate.instant('confirmDeleteRunFlowTaskSchedule', {
          SCHEDULE_NAME: L10n.elideIfLong(schedules.first().name),
          FLOW_COUNT: runFlowTaskCount
        }, L10n.Interpolations.Count);
      } else {
        bodyText = this.$translate.instant('confirmDeleteExtractRefreshSchedule', {
          SCHEDULE_NAME: L10n.elideIfLong(schedules.first().name),
          EXTRACT_COUNT: extractTaskCount
        }, L10n.Interpolations.Count);
      }
    } else {
      bodyText = this.$translate.instant('confirmDeleteSchedules', {
        SCHEDULE_COUNT: scheduleCount,
        TASK_COUNT: extractTaskCount + runFlowTaskCount
      }, L10n.Interpolations.Count);
    }

    return this.ConfirmActionDialog.open({
      scope: context.scope,
      title: this.$translate.instant('deleteMessage'),
      bodyText: bodyText,
      actionName: this.$translate.instant('confirmDeleteButton', {
        ITEM_COUNT: schedules.size()
      }, L10n.Interpolations.Count),
      isDeleteAction: true,

      action: (dialogInstance: IConfirmActionDialogInstance) => {
        return this.Schedules.del(schedules.keys()).then(
          (result: IResult) => this.notifyResult(schedules, result));
      }
    }).result;
  }

  private notifyResult(schedules: Set<ISchedule>, result: IResult) {
    this.ActionHelpers.notifyStandardError(
      schedules,
      {
        successId: 'deleteSchedulesSuccess',
        errorId: 'deleteSchedulesError'
      },
      (errorItem: IErrorItem<ISchedule>) => this.ScheduleErrors.errorDetailsFor(errorItem))(result);
  }

  // returns the number of extract tasks in the given set of schedules
  private countExtractTasks(schedules: Set<ISchedule>) {
    return schedules.reduce(
      (sum: number, s: ISchedule) => sum + (s.scheduledAction === ScheduleActions.Extract ? s.taskCount : 0), 0);
  }

  // returns the number of subscription schedules in the given set of schedules
  private countSubscriptionSchedules(schedules: Set<ISchedule>) {
    return schedules.reduce(
      (sum: number, s: ISchedule) => sum + (s.scheduledAction === ScheduleActions.Subscription ? 1 : 0), 0);
  }

    // returns the number of flow tasks in the given set of schedules
    private countFlowTasks(schedules: Set<ISchedule>) {
      return schedules.reduce(
        (sum: number, s: ISchedule) => sum + (s.scheduledAction === ScheduleActions.Flow ? s.taskCount : 0), 0);
      }

}

Module.instance().service('DeleteSchedulesAction', DeleteSchedulesAction);
